export const requiredRule =
  (message = "Dieses Feld ist ein Pflichtfeld") =>
  (value: string | Array<string>) => {
    if (Array.isArray(value)) {
      return value.length > 0 ? true : message;
    } else {
      return value ? true : message;
    }
  };

export const emailRule =
  (
    message = "Geben Sie bitte Ihre E-Mail-Adresse an. Bitte verwenden Sie das Format name@beispiel.de."
  ) =>
  (value: string) => {
    const emailPattern = /^[a-zA-Z0-9._%+-]+@(?:[a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}$/;
    return emailPattern.test(value) ? true : message;
  };

export const dateRule =
  (data: {
    default: { msg: string };
    min?: { value: Date; msg: string };
    max?: { value: Date; msg: string };
  }) =>
  (value: string) => {
    const date: Date = new Date(value);
    if (isNaN(date.getTime())) {
      return data.default.msg ? data.default.msg : "Bitte ein Datum angeben";
    } else if (
      data.max &&
      date.setHours(0, 0, 0, 0) > data.max.value.setHours(0, 0, 0, 0)
    ) {
      return data.max.msg;
    } else if (
      data.min &&
      date.setHours(0, 0, 0, 0) < data.min.value.setHours(0, 0, 0, 0)
    ) {
      return data.min.msg;
    }
    return true;
  };

export const minLengthRule =
  (data: { value: number; msg: string }) => (value: string) =>
    value && value.length >= data.value
      ? true
      : data.msg
      ? data.msg
      : "Dieses Feld muss mindestens " + data.value + " Zeichen lang sein";

export const maxLengthRule =
  (data: { value: number; msg: string }) => (value: string) =>
    value && value.length <= data.value
      ? true
      : data.msg
      ? data.msg
      : "Dieses Feld darf maximal " + data.value + " Zeichen lang sein";

export const zipRule =
  (
    data: { value: "de" | "at"; msg: string } = {
      value: "de",
      msg: "Bitte geben Sie eine Postleitzahl mit 4 Ziffern für österreich und 5 Ziffern für Deutschland an.",
    }
  ) =>
  (value: string) => {
    const zipPattern = data.value === "at" ? /^[0-9]{4}$/ : /^[0-9]{5}$/;
    return zipPattern.test(value) ? true : data.msg;
  };

export const ibanRule = (value: string) => {
  const ibanPatternDE = /^DE[a-zA-Z0-9]{2}\s?([0-9]{4}\s?){4}([0-9]{2})\s?$/;
  const ibanPatternAT = /^AT[a-zA-Z0-9]{2}\s?([0-9]{4}\s?){4}\s?$/;
  return ibanPatternDE.test(value) || ibanPatternAT.test(value)
    ? true
    : "Bitte geben Sie eine gültige IBAN im korrekten Format ein (z. B. DE89 3704 0044 0532 0130 00).";
};

export const validateForm = (formFields: Array<any>) => {
  let isValid = true;
  for (const key in formFields) {
    if (formFields[key]) {
      const result = formFields[key].validate();
      if (!result) {
        isValid = false;
      }
    }
  }
  return isValid;
};
